export const INITIAL_FIELD_DATA = {
  name: "",
  email: "",
  role: undefined,
};
